import React from "react";
import { motion } from "framer-motion";

export default function AboutSection() {
  return (
    <section className="about-modern" id="about">
      <div className="about-container">
        <motion.div
          className="about-left"
          initial={{ opacity: 0, x: -50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="about-badge">
            <span>🏢</span>
            <span>About Us</span>
          </div>
          
          <h2>About EmberByte Digital Solutions</h2>
          <h3 className="company-tagline">Your software development partner in India—from idea to launch</h3>
          
          <p className="about-description">
            EmberByte Digital Solutions LLP is a software development company in India that
            helps startups and growing businesses build smarter products—combining AI, web,
            mobile, and cloud technology to solve real problems. We don't just write code; we
            partner with you to turn your idea into a product that actually grows your
            business. Transparent pricing, clear timelines, and a team that stays with you
            long after launch.
          </p>

          <div className="about-features">
            <motion.div 
              className="feature-item"
              whileHover={{ x: 10 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <strong>AI-First Thinking</strong>
                <span>We bring smart automation and AI into every product where it adds value</span>
              </div>
            </motion.div>

            <motion.div 
              className="feature-item"
              whileHover={{ x: 10 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <strong>Startup-Friendly</strong>
                <span>Flexible engagement models and pricing that work for growing teams</span>
              </div>
            </motion.div>

            <motion.div 
              className="feature-item"
              whileHover={{ x: 10 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="feature-icon">✓</div>
              <div className="feature-text">
                <strong>End-to-End Partner</strong>
                <span>From idea to launch and beyond—we stay with you through every step</span>
              </div>
            </motion.div>
          </div>
        </motion.div>

        <motion.div
          className="about-right"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="mission-vision-grid">
            <motion.div 
              className="mv-card mission-card"
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 20px 60px rgba(0, 212, 255, 0.4)"
              }}
            >
              <div className="mv-icon">🎯</div>
              <h4>Our Mission</h4>
              <p>
                To make advanced technology—especially AI—accessible and practical for
                every business, helping them work smarter and grow faster.
              </p>
            </motion.div>

            <motion.div 
              className="mv-card vision-card"
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 20px 60px rgba(255, 107, 53, 0.4)"
              }}
            >
              <div className="mv-icon">🚀</div>
              <h4>Our Vision</h4>
              <p>
                To be the most trusted software development and technology partner for
                startups and businesses across India seeking digital transformation and
                sustainable growth.
              </p>
            </motion.div>

            <motion.div 
              className="mv-card values-card"
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 20px 60px rgba(102, 126, 234, 0.4)"
              }}
            >
              <div className="mv-icon">💎</div>
              <h4>Our Values</h4>
              <p>
                Innovation, integrity, excellence, and customer success drive everything 
                we do. We believe in building long-term partnerships.
              </p>
            </motion.div>

            <motion.div 
              className="mv-card commitment-card"
              whileHover={{ 
                scale: 1.05,
                boxShadow: "0 20px 60px rgba(250, 112, 154, 0.4)"
              }}
            >
              <div className="mv-icon">🤝</div>
              <h4>Our Commitment</h4>
              <p>
                We work hard to deliver quality results within agreed timelines. Your
                success is our success, and we're committed to doing our best work on
                every project.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
